export default __webpack_public_path__ + "static/media/avtar.0a0cc436.svg";